import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Router,
  NavigationEnd,
  Event as NavigationEvent,
} from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html',
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;
  @Input('agentSubscriptionData') public agentSubscriptionData: any;
  public intialized: boolean = false;
  public navRoute;

  constructor(private router: Router) {
    this.router.events.subscribe((event: NavigationEvent): void => {
      if (event instanceof NavigationEnd) {
        this.navRoute = this.router.url.split('/')[1];
      }
    });
  }
  ngOnInit() {
    setTimeout(() => {
      this.intialized = true;
    }, 5000);
  }

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        { name: 'SUBITEM', state: 'cards' },
        { name: 'SUBITEM', state: 'buttons' },
      ],
    });
  }

  openContacts() {
    if (this.navRoute == 'contacts') {
      const routerInterval = Observable.interval(10).subscribe(x => {
        this.router
          .navigateByUrl('/property-finder', { skipLocationChange: true })
          .then(() =>
            //initialize a dummy route for redirecting only
            this.router.navigate(['/contacts']),
          );
        routerInterval.unsubscribe();
      });
    } else {
      this.router.navigate(['/contacts']);
    }
  }
}
